
































import { defineComponent, PropType, toRef } from '@nuxtjs/composition-api';
import {
  SfLoader,
} from '@storefront-ui/vue';
import { Product } from '~/modules/catalog/product/types';
import { useProductGallery } from '~/modules/catalog/product/composables/useProductGallery';
import { useProduct3D } from '~/modules/catalog/product/composables/useProduct3D';
import SfGallery from '~/modules/catalog/product/components/SfGallery.vue';

export default defineComponent({
  components: {
    SfLoader,
    SfGallery,
  },
  props: {
    product: {
      type: [Object, null] as PropType<Product | null>,
      default: null,
    },
    isFetching: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const product = toRef(props, 'product');
    const { productGallery, imageSizes } = useProductGallery(product);
    const product3DEntries = useProduct3D(product);

    return {
      productGallery,
      imageSizes,
      product3DEntries,
    };
  },
});
